import { Injectable } from '@angular/core';
import * as mixpanel from 'mixpanel-browser';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';
import { SessionService } from './session.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MixpanelService {
  userName: any;
  isBrowserClosed : boolean =true;
  mainUsername:any;

  constructor(
    private apiService: ApiService,
    private sessionService: SessionService,
    private http: HttpClient
  ) {
    this.userName = this.sessionService.getUsername();
    //this.mixpanelToken = environment.mixpanel_token;
let userdata :any=localStorage.getItem('roles');
     
    this.init();
  }

  /**
   * Initialize mixpanel.
   *
   * @param {string} userToken
   * @memberof MixpanelService
   */
  init(): void {
    mixpanel.init(environment.MixPanelToken);
   // mixpanel.identify(userToken);
  }
  setIdentity(userToken:string): void {
    //mixpanel.init("3e49ec3030837692545f75e53392f748");
   mixpanel.identify(userToken);
  }



  /**
   * Push new action to mixpanel.
   *
   * @param {string} id Name of the action to track.
   * @param {*} [action={}] Actions object with custom properties.
   * @memberof MixpanelService
   */
  track(id: string, action: any = {}): void {

    if(environment.MixPanelTrack){
    mixpanel.track(id, action);
    }

    this.mainUsername = this.sessionService.getMainUsername();
    if(environment.MixPanelDBTrack && id !== 'login' && id !== 'Logout'){
      if(this.mainUsername==this.userName){
         this.userLogActivity(id);
        }
    }

  }
  register(action: any = {}): void {
    
    mixpanel.register(action);
    
  }
  time_event(action: any = {}): void {
    
    mixpanel.time_event(action);
    
  }
  async userLogActivity(event: string): Promise<void> {
    const userActivity: any = {
      user_id: this.userName,
      event_name: event
    };

    // 1️⃣ Try to get Local IP (LAN)
    // userActivity.ip_address = await this.getLocalIP().catch(() => 'Unavailable');

    // 2️⃣ Try to get precise location (latitude, longitude)
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const { latitude, longitude } = pos.coords;
          // userActivity.latitude = latitude;
          // userActivity.longitude = longitude;

          // 3️⃣ Reverse-geocode lat/lon to city, state, country
          const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
          this.http.get(url).subscribe(
            (geo: any) => {
              userActivity.location_name = geo.display_name || 'Unknown';
              userActivity.city = geo.address?.city || geo.address?.town || geo.address?.village || 'Unknown';
              userActivity.state = geo.address?.state || 'Unknown';
              userActivity.country = geo.address?.country || 'Unknown';

              this.sendUserActivity(userActivity);
            },
            (err) => {
              console.error('Reverse geocode failed', err);
              this.sendUserActivity(userActivity);
            }
          );
        },
        (err) => {
          console.warn('Geolocation denied', err);
          this.sendUserActivity(userActivity);
        }
      );
    } else {
      this.sendUserActivity(userActivity);
    }
  }

  /** Send to backend */
  private sendUserActivity(data: any): void {
    this.apiService.userActivity(data).subscribe(
      () => console.log('User activity logged successfully:'),
      (err) => console.error('Error logging user activity', err)
    );
  }

  /** Get local IP address (works on LAN / intranet) */
  private getLocalIP(): Promise<string> {
    return new Promise((resolve, reject) => {
      const pc = new RTCPeerConnection({ iceServers: [] });
      pc.createDataChannel('');
      pc.createOffer()
        .then((offer) => pc.setLocalDescription(offer))
        .catch(reject);

      pc.onicecandidate = (event) => {
        if (!event || !event.candidate) return;
        const candidate = event.candidate.candidate;
        const ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3})/;
        const ipMatch = ipRegex.exec(candidate);
        if (ipMatch) {
          resolve(ipMatch[1]);
          pc.close();
        }
      };

      setTimeout(() => reject('Timeout'), 3000);
    });
  }
}
